export function getBodyScrollTop() {
  const element = document.scrollingElement || document.documentElement
  return element.scrollTop
}
